import React, { useContext, useEffect, useState } from "react";
import axios from "../axios";
import LoginContext from "../context/LoginContext";
import Search from "../components/Search";
import Formula from "../components/Formula";
import { useCookies } from "react-cookie";

function Mixer() {
  const [cookies, setCookies] = useCookies();
  const [formula, setFormula] = useState();
  const [multiplier, setMultiplier] = useState(1000);
  const [addedToMyFormulas, setAddedToMyFormulas] = useState(false);
  const { isLoggedIn, setIsLoggedIn } = useContext(LoginContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const category = e.target.elements.category.value;
    const colorCode = e.target.elements.colorCode.value;
    try {
      const response = await axios.get(`/formulas/${colorCode}/${category}`);
      setFormula(response.data);
      setAddedToMyFormulas(false);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const checkToken = async () => {
      try {
        const response = await axios.get("/users/checkToken", {
          headers: { "x-access-token": cookies.access_token },
        });
        if (response.data.message === "Valid") {
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
        }
      } catch (err) {
        console.log(err);
      }
    };
    checkToken();
  }, []);

  return (
    <div className="container-lg">
      <Search
        handleSubmit={(e) => handleSubmit(e)}
        setMultiplier={(e) => setMultiplier(e.target.value)}
        setAddedToMyFormulas={(added) => setAddedToMyFormulas(added)}
      />
      <Formula
        formula={formula}
        multiplier={multiplier}
        addedToMyFormulas={addedToMyFormulas}
        setAddedToMyFormulas={(added) => setAddedToMyFormulas(added)}
      />
    </div>
  );
}

export default Mixer;
